import Tout5050 from './tout5050';
export default Tout5050;
